import React from 'react';
import CustomPeriod from './CustomPeriod';
import CalendarInput from './CalendarInput';

const PeriodSelector = ({
  startDate,
  endDate,
  changePeriod,
  customPeriodOption,
}) => {
  return (
    <>
      <CustomPeriod
        changePeriod={changePeriod}
        customPeriodOption={customPeriodOption}
      />
      <span className="container-search-or-span">ou</span>
      <div className="container-period-calendars">
        <div className="search-ultimos-dias">
          <span>de:</span>
          <CalendarInput
            date={startDate}
            changeDate={(newDate) => changePeriod(newDate, endDate, 0)}
          />
        </div>
        <div className="search-ultimos-dias">
          <span className="ml-4">até:</span>
          <CalendarInput
            date={endDate}
            changeDate={(newDate) => changePeriod(startDate, newDate, 0)}
          />
        </div>
      </div>
    </>
  );
};

export default PeriodSelector;
